export default "__VITE_ASSET__BR7oFo89__"